import React, { useState, useEffect } from 'react';
import { AuthContext, useAuth } from './contexts/AppAuthContext';
import './App.css';
import './LandingPage.css';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
// XLSX movido para components/content/CustomersContent.js (Fase 2 refactor)
import LandingPage from './LandingPage';
import PublicMenu from './PublicMenu';
import KanbanBoard from './components/KanbanBoard';
import PixPaymentModal from './components/PixPaymentModal';
import PDVScreen from './PDVScreen';
import { OccupationTimer, TablesDashboard, TableFilters } from './TableManagementImproved';
import CouponsContent from './CouponsContent';
import AppearanceSettings from './AppearanceSettings';
import StockManagement from './StockManagement';
import CardOnlineSettings from './CardOnlineSettings';
import TeamManagementContent from './TeamManagement';
// StatusMessagesPanel movido para components/content/WhatsAppContent.js (Fase 2 refactor)
import FinancialMetricsPanel from './FinancialMetricsPanel';
// import WhatsAppCRM from './WhatsAppCRM'; // Removido - funcionalidade inacabada
// GreetingMessageSettings movido para components/content/WhatsAppContent.js (Fase 2 refactor)
// AwayMessageSettings movido para components/content/WhatsAppContent.js (Fase 2 refactor)
import WaiterSelector, { getDefaultWaiter } from './components/WaiterSelector';
import { useWhatsAppIntegration, generateWhatsAppLink } from './hooks/useWhatsAppIntegration';
import { 
  MasterRestaurantsContent, 
  MasterAnalyticsContent, 
  MasterReportsContent, 
  MasterTemplatesContent, 
  MasterActionLogsContent,
  MasterSystemSettingsContent,
  MasterAIErrorLogsContent,
  MasterGalleryContent,
  MasterProspectionContent,
  MasterUazAPIContent,
  MasterBackupContent,
  MasterAIUsageContent,
  MasterAIKeyPoolContent
} from './MasterPanel';

// Componentes extraídos (refatoração)
import { MyPlanContent, OrdersContent, CashbackContent, AdditionalsContent, CategoriesContent, AdditionalGroupsContent, CustomersContent, DeliveryZonesContent, WhatsAppContent } from './components/content';
import KDSScreen from './components/content/KDSScreen';
import { fuzzyMatch } from './utils/helpers';
import DeliveryDriversContent from './components/content/DeliveryDriversContent';
import CashRegisterContent from './components/content/CashRegisterContent';
import ReportsContent from './components/content/ReportsContent';
import TableManagementContent from './components/content/TableManagementContent';
import SettingsContent from './components/content/SettingsContent';
import ProductsContent from './components/content/ProductsContent';
import Dashboard from './Dashboard';
import DeliveryZonesMap from './components/DeliveryZonesMap';
// ShippingPromoConfig movido para components/content/DeliveryZonesContent.js (Fase 2 refactor)
// CampaignsPanel movido para components/content/CustomersContent.js (Fase 2 refactor)

// Subdomain detection utility
import { extractSubdomain, isStoreSubdomain } from './utils/subdomain';

import { 
  ChefHat, 
  Zap, 
  ShoppingCart, 
  Package, 
  Boxes,
  Tag, 
  Plus, 
  Settings,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Search,
  Sun,
  Moon,
  Waves,
  Bell,
  AlertCircle,
  User,
  LogOut,
  PlusCircle,
  Edit,
  Trash2,
  Eye,
  EyeOff,
  Filter,
  Clock,
  DollarSign,
  CheckCircle,
  XCircle,
  Palette,
  ExternalLink,
  Star,
  Download,
  Upload,
  FileSpreadsheet,
  FileText,
  Truck,
  MapPin,
  Store,
  Shield,
  CheckSquare,
  TrendingUp,
  MoreVertical,
  Printer,
  Copy,
  Sliders,
  UserCog,
  QrCode,
  Users,
  ArrowLeft,
  CreditCard,
  Banknote,
  Smartphone,
  UserCircle,
  UsersRound,
  Ticket,
  MessageSquare,
  Send,
  Phone,
  Wallet,
  Home,
  RefreshCw,
  RefreshCcw,
  Bot,
  Calendar,
  X,
  Layers,
  Check,
  Key,
  Image as ImageIcon,
  Bike,
  AlertTriangle,
  Navigation,
  Sparkles,
  Target,
  Camera,
  FileImage,
  Mic,
  Ban
} from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from './components/ui/dialog';
import { Switch } from './components/ui/switch';
import { Label } from './components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './components/ui/select';
import { toast } from 'sonner';
import { Toaster } from './components/ui/sonner';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from './components/ui/dropdown-menu';

// Determinar URL do backend baseado no ambiente
// Em QUALQUER ambiente Emergent (preview ou deploy), usar a mesma origem (window.location.origin)
// O Kubernetes ingress roteia /api para o backend automaticamente
const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    
    // Produção custom domain
    if (currentHost === 'pedeefacil.com.br' || currentHost === 'www.pedeefacil.com.br') {
      return 'https://pedeefacil.com.br';
    }
    
    // Para QUALQUER outro ambiente (preview, deploy, etc) usar mesma origem
    // Isso garante que o frontend sempre fala com o backend correto
    return window.location.origin;
  }
  
  // Server-side fallback
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
};

const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

// VERSÃO DO CÓDIGO - para verificar se o deploy está atualizado
const CODE_VERSION = "2026-03-28-v5-url-fix";
console.log('🚀 CODE_VERSION:', CODE_VERSION);

// Debug: Log da URL da API
console.log('🔧 BACKEND_URL:', BACKEND_URL);
console.log('🔧 API:', API);
console.log('🔧 Current hostname:', typeof window !== 'undefined' ? window.location.hostname : 'N/A');

// ==================== REFRESH TOKEN AUTOMÁTICO ====================

// Função para decodificar JWT e verificar expiração
const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => 
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  // Token expira em menos de 5 minutos? Considerar expirado
  const expiresAt = decoded.exp * 1000;
  const now = Date.now();
  const fiveMinutes = 5 * 60 * 1000;
  
  return (expiresAt - now) < fiveMinutes;
};

const isTokenCompletelyExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  return (decoded.exp * 1000) < Date.now();
};

// Flag para evitar múltiplas requisições de refresh simultâneas
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onRefreshed = (newToken) => {
  refreshSubscribers.forEach(cb => cb(newToken));
  refreshSubscribers = [];
};

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refresh_token');
  
  if (!refreshToken) {
    throw new Error('No refresh token');
  }
  
  try {
    const response = await axios.post(`${API}/refresh-token`, {
      refresh_token: refreshToken
    }, {
      headers: {},  // Sem Authorization para não entrar em loop
      timeout: 10000  // Timeout próprio para refresh (10s)
    });
    
    const { access_token } = response.data;
    localStorage.setItem('token', access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    
    console.log('🔄 Token renovado automaticamente');
    return access_token;
  } catch (error) {
    // Se for erro de rede/servidor, NÃO limpar tokens (sessão pode estar válida)
    const status = error.response?.status;
    const isNetworkError = !error.response || status === 503 || status === 502 || status === 504 || error.code === 'ECONNABORTED';
    
    if (isNetworkError) {
      console.warn('⚡ Refresh falhou por erro de rede - mantendo tokens');
      throw error;  // Propagar sem limpar
    }
    
    // Erro de autenticação real (401, 400) - limpar tokens
    console.error('❌ Refresh token inválido/expirado - limpando sessão');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    throw error;
  }
};

// Timeout padrão para todas as requisições (15s)
// Evita requests pendurados que travam a UI
axios.defaults.timeout = 30000;

// Interceptor de requisição - Verifica e renova token se necessário
axios.interceptors.request.use(
  async (config) => {
    // Não verificar token para endpoints de auth
    const isAuthEndpoint = config.url?.includes('/login') || 
                           config.url?.includes('/refresh-token') ||
                           config.url?.includes('/register');
    
    if (isAuthEndpoint) {
      return config;
    }
    
    let token = localStorage.getItem('token');
    
    if (token) {
      // Verificar se token está próximo de expirar
      if (isTokenExpired(token) && !isRefreshing) {
        isRefreshing = true;
        
        try {
          token = await refreshAccessToken();
          onRefreshed(token);
        } catch (error) {
          // Se falhar, continuar com o token atual (pode dar 401)
          console.warn('⚠️ Não foi possível renovar token, usando atual');
        } finally {
          isRefreshing = false;
        }
      } else if (isRefreshing) {
        // Se já está renovando, aguardar
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            config.headers.Authorization = `Bearer ${newToken}`;
            resolve(config);
          });
        });
      }
      
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de resposta - Trata erros 401 e 520
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Ignorar erros de refresh-token para evitar loop infinito
    if (originalRequest?.url?.includes('/refresh-token')) {
      return Promise.reject(error);
    }
    
    // NUNCA fazer logout por erros de rede/servidor (503, timeout, network error)
    // Esses erros são transitórios e não significam que a sessão expirou
    const status = error.response?.status;
    const isNetworkError = !error.response || status === 503 || status === 502 || status === 504 || error.code === 'ECONNABORTED';
    
    if (isNetworkError) {
      console.warn(`⚡ Erro de rede/servidor (${status || 'timeout'}) em ${originalRequest?.url} - NÃO fazer logout`);
      return Promise.reject(error);
    }
    
    // IMPORTANTE: Verificar se é master admin - NÃO fazer logout automático para master
    const savedRestaurant = localStorage.getItem('restaurant');
    let isMasterAdmin = false;
    try {
      isMasterAdmin = savedRestaurant ? JSON.parse(savedRestaurant)?.is_master : false;
    } catch (e) {
      // Ignorar erro de parse
    }
    
    // Rotas que NUNCA devem causar logout
    const ignoredRoutes = [
      '/public/',
      '/login',
      '/register',
      '/check-master',
      '/whatsapp/status',
      '/whatsapp/ai-config',
      '/me',
      '/health',
      '/master/restaurants'
    ];
    
    const requestUrl = originalRequest?.url || '';
    const shouldIgnore = ignoredRoutes.some(route => requestUrl.includes(route));
    
    // Se for erro 401 ou 520 e não é retry
    if ((status === 401 || status === 520) && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Para master admin ou rotas ignoradas, NÃO fazer logout - apenas rejeitar
      if (isMasterAdmin || shouldIgnore) {
        console.log('⏭️ Master admin ou rota ignorada - não fazendo logout para:', requestUrl);
        return Promise.reject(error);
      }
      
      const refreshToken = localStorage.getItem('refresh_token');
      
      // Se tem refresh token, tentar renovar
      if (refreshToken) {
        try {
          console.log('🔄 Tentando renovar token após 401...');
          const newToken = await refreshAccessToken();
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          console.log('✅ Token renovado, repetindo requisição...');
          return axios(originalRequest);
        } catch (refreshError) {
          // Se o refresh falhou por erro de rede, NÃO fazer logout
          const refreshStatus = refreshError.response?.status;
          const isRefreshNetworkError = !refreshError.response || refreshStatus === 503 || refreshStatus === 502 || refreshStatus === 504;
          
          if (isRefreshNetworkError) {
            console.warn('⚡ Refresh falhou por erro de rede - mantendo sessão');
            return Promise.reject(error);
          }
          
          // Refresh falhou - mas NÃO fazer logout para master admin
          if (isMasterAdmin) {
            console.log('⚠️ Refresh falhou para master, mas mantendo sessão');
            return Promise.reject(refreshError);
          }
          
          // Refresh falhou por auth inválida - fazer logout
          console.error('❌ Token realmente expirado. Fazendo logout.');
          localStorage.removeItem('token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('restaurant');
          localStorage.removeItem('isImpersonating');
          
          window.dispatchEvent(new CustomEvent('session-expired'));
          
          return Promise.reject(refreshError);
        }
      } else {
        // Sem refresh token - mas NÃO fazer logout para master admin
        if (isMasterAdmin) {
          console.log('⚠️ Sem refresh token para master, mas mantendo sessão');
          return Promise.reject(error);
        }
        
        // Sem refresh token - fazer logout para usuários normais
        console.log('⚠️ Sem refresh token, fazendo logout...');
        localStorage.removeItem('token');
        localStorage.removeItem('restaurant');
        localStorage.removeItem('isImpersonating');
        window.dispatchEvent(new CustomEvent('session-expired'));
      }
    }
    
    return Promise.reject(error);
  }
);

// Color options for categories

// Auth Context (AuthContext + useAuth) movido para ./contexts/AppAuthContext.js (Fase 2 refactor)

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateAndRestoreSession = async () => {
      const token = localStorage.getItem('token');
      const savedRestaurant = localStorage.getItem('restaurant');
      
      if (token && savedRestaurant) {
        try {
          // Set token in axios headers
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          
          // Para master admin, usar os dados salvos sem validar com /me
          // (porque /me exige restaurant_id que master não tem)
          const restaurantData = JSON.parse(savedRestaurant);
          if (restaurantData.is_master) {
            setUser({ token });
            setRestaurant(restaurantData);
            console.log('✅ Sessão master restaurada (sem validação /me)');
            setLoading(false);
            return;
          }
          
          // Para usuários normais, validar com /me
          try {
            const response = await axios.get(`${API}/me`);
            setUser({ token });
            setRestaurant(response.data);
            console.log('✅ Sessão restaurada com sucesso');
          } catch (meError) {
            // Se /me falhar, usar dados salvos (pode estar offline ou servidor ocupado)
            console.log('⚠️ /me falhou, usando dados salvos:', meError.message);
            setUser({ token });
            setRestaurant(restaurantData);
          }
        } catch (error) {
          // Erro ao parsear dados salvos - limpar tudo
          console.log('⚠️ Erro ao restaurar sessão:', error.message);
          localStorage.removeItem('token');
          localStorage.removeItem('restaurant');
          localStorage.removeItem('isImpersonating');
          delete axios.defaults.headers.common['Authorization'];
        }
      }
      setLoading(false);
    };
    
    validateAndRestoreSession();
  }, []);

  const login = async (email, password) => {
    try {
      console.log('Attempting login with:', email);
      const response = await axios.post(`${API}/login`, { email, password });
      console.log('Login response:', response.data);
      const { access_token, refresh_token, restaurant } = response.data;
      
      localStorage.setItem('token', access_token);
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token);
      }
      localStorage.setItem('restaurant', JSON.stringify(restaurant));
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      
      setUser({ token: access_token });
      setRestaurant(restaurant);
      console.log('Login successful, redirecting...');
      return true;
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  };

  const register = async (name, whatsapp, email, password, isMaster = false) => {
    try {
      console.log('Attempting registration with:', { name, whatsapp, email, is_master: isMaster });
      const response = await axios.post(`${API}/register`, { 
        name, whatsapp, email, password, is_master: isMaster
      });
      console.log('Registration response:', response.data);
      const { access_token, refresh_token, restaurant } = response.data;
      
      localStorage.setItem('token', access_token);
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token);
      }
      localStorage.setItem('restaurant', JSON.stringify(restaurant));
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      
      setUser({ token: access_token });
      setRestaurant(restaurant);
      console.log('Registration successful, redirecting...');
      return true;
    } catch (error) {
      console.error('Register error:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('restaurant');
    localStorage.removeItem('isImpersonating');  // Remove impersonation flag
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setRestaurant(null);
  };
  
  // Listener para sessão expirada (disparado pelo interceptor)
  useEffect(() => {
    const handleSessionExpired = () => {
      console.log('⚠️ Sessão expirada - fazendo logout...');
      // Resetar estados
      setUser(null);
      setRestaurant(null);
      setLoading(false);  // IMPORTANTE: Garantir que loading seja resetado
      // Limpar storage
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('restaurant');
      localStorage.removeItem('isImpersonating');
      delete axios.defaults.headers.common['Authorization'];
      // Mostrar mensagem ao usuário (sem alert para não travar)
      console.log('ℹ️ Por favor, faça login novamente.');
    };
    
    window.addEventListener('session-expired', handleSessionExpired);
    
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  // Auto-persist restaurant data to localStorage whenever it changes
  useEffect(() => {
    if (restaurant) {
      localStorage.setItem('restaurant', JSON.stringify(restaurant));
      console.log('💾 Dados do restaurante salvos automaticamente');
    }
  }, [restaurant]);

  // Refresh restaurant data periodically and on focus to keep it in sync
  useEffect(() => {
    if (!user?.token) return;
    
    // Para master admin, não precisa fazer refresh via /me
    // Os dados já estão no localStorage e o master não precisa de dados de restaurante específico
    const savedRestaurant = localStorage.getItem('restaurant');
    const restaurantData = savedRestaurant ? JSON.parse(savedRestaurant) : null;
    if (restaurantData?.is_master) {
      console.log('🔑 Master admin detectado - pulando refresh via /me');
      return;
    }

    const refreshRestaurantData = async () => {
      try {
        const response = await axios.get(`${API}/me`);
        setRestaurant(response.data);
        console.log('🔄 Dados do restaurante atualizados automaticamente');
      } catch (error) {
        // Se for 404, não fazer nada (pode ser master admin ou restaurante não encontrado)
        if (error.response?.status === 404) {
          console.log('⚠️ /me retornou 404 - mantendo dados existentes');
          return;
        }
        console.log('⚠️ Erro ao atualizar dados do restaurante:', error.message);
      }
    };

    // Initial refresh on mount
    refreshRestaurantData();

    // Refresh restaurant data every 2 minutes
    const interval = setInterval(refreshRestaurantData, 2 * 60 * 1000);

    // Refresh when window gains focus (user returns to tab)
    const handleFocus = () => {
      console.log('👀 Janela ganhou foco, atualizando dados...');
      refreshRestaurantData();
    };
    
    window.addEventListener('focus', handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, [user]);

  // Heartbeat to keep session alive - ping server every 30 minutes
  useEffect(() => {
    if (!user?.token) return;
    
    // Para master admin, usar endpoint de health ao invés de /me
    const savedRestaurant = localStorage.getItem('restaurant');
    const restaurantData = savedRestaurant ? JSON.parse(savedRestaurant) : null;
    const isMaster = restaurantData?.is_master;

    const heartbeat = async () => {
      try {
        // Master admin usa /health, lojistas usam /me
        const endpoint = isMaster ? `${API}/health` : `${API}/me`;
        await axios.get(endpoint);
        console.log('💓 Heartbeat: sessão mantida ativa');
      } catch (error) {
        // Não fazer logout em caso de erro - apenas logar
        console.log('💔 Heartbeat falhou:', error.message);
      }
    };

    // Run heartbeat every 30 minutes
    const interval = setInterval(heartbeat, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user]);

  return (
    <AuthContext.Provider value={{ 
      user, 
      restaurant, 
      setUser,
      setRestaurant,
      login, 
      register, 
      logout, 
      loading 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

// Public Menu Route Component (path-based: /menu/:subdomain)
const PublicMenuRoute = () => {
  const { subdomain } = useParams();
  
  // You can fetch restaurant data based on subdomain here
  // For now, we'll use the PublicMenu component directly
  
  return <PublicMenu subdomain={subdomain} />;
};

// Subdomain-based Public Menu Component (for {slug}.pedeefacil.shop)
const SubdomainMenuRoute = () => {
  const subdomain = extractSubdomain();
  
  if (!subdomain) {
    // Shouldn't happen, but fallback to landing page
    return <Navigate to="/" replace />;
  }
  
  return <PublicMenu subdomain={subdomain} />;
};

// Login Component
const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    whatsapp: '',
    email: '',
    password: '',
    isMaster: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [masterAvailable, setMasterAvailable] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  // Verificar se master está disponível
  useEffect(() => {
    const checkMasterAvailable = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/auth/check-master-available`);
        setMasterAvailable(response.data.available);
      } catch (error) {
        console.error('Erro ao verificar master:', error);
        setMasterAvailable(false);
      }
    };
    
    if (!isLogin) {
      checkMasterAvailable();
    }
  }, [isLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Retry logic: até 3 tentativas para erros de rede
    const maxRetries = 3;
    let lastError = null;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        if (isLogin) {
          await login(formData.email, formData.password);
        } else {
          await register(formData.name, formData.whatsapp, formData.email, formData.password, formData.isMaster);
        }
        
        navigate('/dashboard', { replace: true });
        setLoading(false);
        return;
      } catch (error) {
        lastError = error;
        
        // Se o backend respondeu com um erro específico, NÃO tentar de novo
        if (error.response?.status) {
          // 429 = Rate limit
          if (error.response.status === 429) {
            setError(error.response.data?.detail || 'Muitas tentativas. Aguarde 1 minuto.');
            setLoading(false);
            return;
          }
          // 400/401/422 = Erro de validação/autenticação - não adianta retry
          if ([400, 401, 422].includes(error.response.status)) {
            setError(error.response.data?.detail || 'Email ou senha incorretos');
            setLoading(false);
            return;
          }
          // 500+ = Erro do servidor - tentar retry
          if (error.response.status >= 500 && attempt < maxRetries) {
            console.warn(`Tentativa ${attempt}/${maxRetries} falhou (${error.response.status}). Tentando novamente...`);
            await new Promise(r => setTimeout(r, 2000 * attempt));
            continue;
          }
        }
        
        // Erro de rede (sem response) - tentar retry com delay crescente
        if (!error.response && attempt < maxRetries) {
          console.warn(`Erro de rede na tentativa ${attempt}/${maxRetries}. Tentando novamente em ${2 * attempt}s...`);
          await new Promise(r => setTimeout(r, 2000 * attempt));
          continue;
        }
      }
    }
    
    // Todas as tentativas falharam
    if (lastError?.response?.data?.detail) {
      setError(lastError.response.data.detail);
    } else if (lastError?.response?.status === 429) {
      setError('Muitas tentativas. Aguarde 1 minuto.');
    } else if (!lastError?.response) {
      setError('Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.');
    } else {
      setError('Erro ao processar solicitação. Tente novamente.');
    }
    
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      padding: '16px'
    }}>
      
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '16px',
        boxShadow: '0 20px 48px rgba(0, 0, 0, 0.2)',
        width: '100%',
        maxWidth: '450px',
        position: 'relative'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
            <div style={{ position: 'relative' }}>
              <ChefHat style={{ width: '48px', height: '48px', color: '#3b82f6' }} />
              <Zap style={{ width: '24px', height: '24px', color: '#fbbf24', position: 'absolute', top: '-4px', right: '-4px' }} />
            </div>
          </div>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#111827', marginBottom: '8px' }}>
            {isLogin ? 'Bem-vindo ao Pede é Fácil!' : 'Criar Conta'}
          </h1>
          <p style={{ color: '#6b7280' }}>
            {isLogin ? 'Acesse seu painel de controle' : 'Comece agora gratuitamente'}
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {!isLogin && (
            <>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
                  Nome do Restaurante
                </label>
                <input
                  type="text"
                  required
                  data-testid="register-name-input"
                  style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '15px' }}
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Seu Restaurante"
                />
                {formData.name.trim().length > 0 && (
                  <p style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                    Seu cardápio: <strong>pedeefacil.com.br/menu/{
                      formData.name
                        .normalize('NFKD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, '-')
                        .replace(/^-+|-+$/g, '') || 'sua-loja'
                    }</strong>
                  </p>
                )}
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
                  WhatsApp da sua loja
                </label>
                <input
                  type="tel"
                  required
                  inputMode="tel"
                  data-testid="register-whatsapp-input"
                  style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '15px' }}
                  value={formData.whatsapp}
                  onChange={(e) => {
                    const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
                    let masked = digits;
                    if (digits.length > 0) masked = `(${digits.slice(0, 2)}`;
                    if (digits.length >= 3) masked += `) ${digits.slice(2, 7)}`;
                    if (digits.length >= 8) masked += `-${digits.slice(7, 11)}`;
                    setFormData({ ...formData, whatsapp: masked });
                  }}
                  placeholder="(11) 99999-9999"
                />
              </div>
            </>
          )}
          
          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
              Email
            </label>
            <input
              type="email"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '15px'
              }}
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              placeholder="seu@email.com"
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
              Senha
            </label>
            <input
              type="password"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '15px'
              }}
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              placeholder="••••••••"
            />
          </div>

          {!isLogin && masterAvailable && (
            <div style={{
              padding: '16px',
              background: '#fef3c7',
              border: '2px solid #f59e0b',
              borderRadius: '8px',
              marginTop: '8px'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                gap: '12px'
              }}>
                <input
                  type="checkbox"
                  checked={formData.isMaster}
                  onChange={(e) => setFormData({...formData, isMaster: e.target.checked})}
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{ 
                    fontSize: '15px', 
                    fontWeight: '600', 
                    color: '#92400e',
                    marginBottom: '4px'
                  }}>
                    🔑 Criar como Gestor Master
                  </div>
                  <div style={{ 
                    fontSize: '13px', 
                    color: '#92400e'
                  }}>
                    Primeira conta com acesso total ao sistema. Disponível apenas uma vez!
                  </div>
                </div>
              </label>
            </div>
          )}

          {error && (
            <div style={{
              padding: '12px',
              background: '#fee2e2',
              color: '#991b1b',
              borderRadius: '8px',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? '#9ca3af' : '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s'
            }}
          >
            {loading ? 'Processando...' : (isLogin ? 'Entrar' : 'Criar Conta')}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <button
            onClick={() => setIsLogin(!isLogin)}
            style={{
              color: '#3b82f6',
              fontWeight: '500',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
          >
            {isLogin ? 'Não tem conta? Registre-se' : 'Já tem conta? Faça login'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Main Dashboard Component
// Dashboard extraido -> ./Dashboard.js (Fase 2 refactor)

// MyPlanContent foi extraído para ./components/content/MyPlanContent.js

// Categories Content Component
// CategoriesContent extraido -> components/content/CategoriesContent.js (Fase 2 refactor)



// Additional Groups Content Component
// AdditionalGroupsContent extraido -> components/content/AdditionalGroupsContent.js (Fase 2 refactor)

// Additionals Content Component
// AdditionalsContent extraido -> components/content/AdditionalsContent.js (Fase 2 refactor)

// OrdersContent foi extraído para ./components/content/OrdersContent.js

// Public Menu Content Component
// PublicMenuContent extraido -> components/content/PublicMenuContent.js (Fase 2 refactor; componente nao referenciado no App.js)


// ===== Status (Stories) Posts Scheduler =====
// WhatsAppContent (+ StatusPostsManager/WEEKDAYS/emptyStatusForm) extraido -> components/content/WhatsAppContent.js (Fase 2 refactor)

// WhatsAppContent component ends here

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 flex items-center justify-center">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

// Main App Component
function App() {
  // Check if we're on a store subdomain
  const storeSubdomain = extractSubdomain();
  const isOnStoreSubdomain = isStoreSubdomain();
  
  // If on a store subdomain, render only the public menu
  if (isOnStoreSubdomain && storeSubdomain) {
    return (
      <div className="App">
        <Toaster position="top-right" expand={false} richColors />
        <BrowserRouter>
          <Routes>
            {/* All routes on store subdomain show the public menu */}
            <Route path="*" element={<PublicMenu subdomain={storeSubdomain} />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
  
  // Componente para redirecionar baseado no estado de autenticação
  // Para PWA/atalho: pula a landing page e vai direto pro login ou dashboard
  const SmartHomeRoute = () => {
    const token = localStorage.getItem('token');
    const savedRestaurant = localStorage.getItem('restaurant');
    
    // Verificar se é um acesso via PWA (standalone mode)
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true ||
                  document.referrer.includes('android-app://');
    
    // Se tem credenciais salvas, vai direto pro dashboard
    if (token && savedRestaurant) {
      return <Navigate to="/dashboard" replace />;
    }
    
    // Se é PWA ou tem indicação de acesso direto, vai pro login
    if (isPWA) {
      return <Navigate to="/login" replace />;
    }
    
    // Caso contrário, mostra a landing page normal
    return <LandingPage />;
  };

  // Normal app routing for main domain
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" expand={false} richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SmartHomeRoute />} />
            <Route path="/login" element={<LoginPage />} />
            {/* Legacy route - will be redirected by backend in production */}
            <Route path="/menu/:subdomain" element={<PublicMenuRoute />} />
            {/* Rota /cardapio/:subdomain */}
            <Route path="/cardapio/:subdomain" element={<PublicMenuRoute />} />
            {/* Rota /loja/:subdomain */}
            <Route path="/loja/:subdomain" element={<PublicMenuRoute />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
